import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('useCaseSelection', ['hasNoTaskSortUseCase', 'hasOrderSortUseCase', 'isOnlyNoTaskSortUseCase', 'hasUseCaseOnWorkInstruction'])
  }
}



// WEBPACK FOOTER //
// ./src/mixins/use-case-selection.mixin.js